import { render, staticRenderFns } from "./forceTypeDetail.vue?vue&type=template&id=de5de688&scoped=true"
import script from "./forceTypeDetail.vue?vue&type=script&lang=js"
export * from "./forceTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./forceTypeDetail.vue?vue&type=style&index=0&id=de5de688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5de688",
  null
  
)

export default component.exports